module.exports = __webpack_public_path__ + "media/images/general/icon_blank-e55e0351faaa08c3e029063b38caf9c1.svg";